let product_info_wrapper = document.getElementById("product_info_wrapper");
var lastScrollTop = 0;
var header_wrapper = document.querySelector(".header-wrapper");

window.onscroll = () => {
  
  let x = product_info_wrapper.clientHeight;
  let h = innerHeight;
  let bottom_scroll;
  let header_height = header_wrapper.clientHeight;
  if(x > h) {
  bottom_scroll = h - x;
  } else {
     bottom_scroll = 0;
  }
  var st = window.pageYOffset || document.documentElement.scrollTop; 
   if (st > lastScrollTop){
     product_info_wrapper.style.top = bottom_scroll + "px";
   } else {
     product_info_wrapper.style.top = header_height + "px";
   }
  lastScrollTop = st <= 0 ? 0 : st;
}